module.exports = __webpack_public_path__ + "static/media/iconeMesa.7a286a2f.svg";